import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Paper, Typography, useTheme    
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ptBR } from '@mui/x-data-grid/locales';
import { FranquiaService, IDetalheFranquia, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService} from "../../shered/services/api/draft/DraftService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";

// const rows = [
//     { id: 1, donoPick: 'Snow', origemPick: '', nomeJogador: 'Jon', foto: "../../trofel_NBA_2.png" },
//     { id: 2, donoPick: 'Lannister', origemPick: '', nomeJogador: 'Cersei', foto: "../../trofel_NBA_2.png" },
//     { id: 3, donoPick: 'Lannister', origemPick: '', nomeJogador: 'Jaime', foto: "../../trofel_NBA_2.png" },
//     { id: 4, donoPick: 'Stark', origemPick: '', nomeJogador: 'Arya', foto: "../../trofel_NBA_2.png" },
//     { id: 5, donoPick: 'Targaryen', origemPick: '', nomeJogador: 'Daenerys', foto: "../../trofel_NBA_2.png" },
//     { id: 6, donoPick: 'Melisandre', origemPick: '', nomeJogador: null, foto: "../../trofel_NBA_2.png" },
//     { id: 7, donoPick: 'Clifford', origemPick: '', nomeJogador: 'Ferrara', foto: "../../trofel_NBA_2.png" },
//     { id: 8, donoPick: 'Frances', origemPick: '', nomeJogador: 'Rossini', foto: "../../trofel_NBA_2.png" },
//     { id: 9, donoPick: 'Roxie', origemPick: '', nomeJogador: 'Harvey', foto: "../../trofel_NBA_2.png" },
// ];

interface IGridColumnHeaderParams {
    id: string;
    ano1: string;
    ano2: string;
    ano3: string;
    ano4: string;
    ano5: string;
}

const rows = [
    { id: 1, "2023/2024": "1.200.000,00", "2024/2025": "1.400.000,00", "2025/2026": "1.600.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 2, "2023/2024": "1.210.000,00", "2024/2025": "1.410.000,00", "2025/2026": "1.610.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 3, "2023/2024": "1.220.000,00", "2024/2025": "1.420.000,00", "2025/2026": "1.620.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 4, "2023/2024": "1.230.000,00", "2024/2025": "1.430.000,00", "2025/2026": "1.630.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 5, "2023/2024": "1.240.000,00", "2024/2025": "1.440.000,00", "2025/2026": "1.640.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 6, "2023/2024": "1.250.000,00", "2024/2025": "1.450.000,00", "2025/2026": "1.650.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 7, "2023/2024": "1.260.000,00", "2024/2025": "1.460.000,00", "2025/2026": "1.660.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 8, "2023/2024": "1.270.000,00", "2024/2025": "1.470.000,00", "2025/2026": "1.670.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
    { id: 9, "2023/2024": "1.280.000,00", "2024/2025": "1.480.000,00", "2025/2026": "1.680.000,00", "2026/2027": "1.800.000,00", "2027/2028": "2.000.000,00" },
];


export const ListagemDraftSalarios: React.FC = () => {
    const theme = useTheme();
    const { formRef, save } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, logout } = useAuthContext();
    const { themeName } = useAppThemeContext();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    //const [rows, setRows] = useState<IDetalheDraftPicksTable[]>([]);
    const [searchParamsSalarios, SetSearchParams] = useSearchParams();
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [dadosHeader, setDadosHeader] = useState<IGridColumnHeaderParams>({
        id: "ID", ano1: "2023/2024", ano2: "2024/2025", ano3: "2025/2026", ano4: "2026/2027", ano5: "2027/2028"
    });


    const columnsSalarios: GridColDef[] = [
        {
            field: `${dadosHeader.id.toLowerCase()}`,
            headerName: `${dadosHeader.id}`,
            width: 90,
            headerClassName: 'super-app-theme--header',
        }, {
            field: `${dadosHeader.ano1}`,
            headerName: `${dadosHeader.ano1}`,
            flex: 1,
            editable: false,
            headerClassName: 'super-app-theme--header',
        }, {
            field: `${dadosHeader.ano2}`,
            headerName: `${dadosHeader.ano2}`,
            flex: 1,
            editable: false,
            headerClassName: 'super-app-theme--header',
        }, {
            field: `${dadosHeader.ano3}`,
            headerName: `${dadosHeader.ano3}`,
            flex: 1,
            editable: false,
            headerClassName: 'super-app-theme--header',
        }, {
            field: `${dadosHeader.ano4}`,
            headerName: `${dadosHeader.ano4}`,
            flex: 1,
            editable: false,
            headerClassName: 'super-app-theme--header',
        }, {
            field: `${dadosHeader.ano5}`,
            headerName: `${dadosHeader.ano5}`,
            flex: 1,
            editable: false,
            headerClassName: 'super-app-theme--header',
        },

    ];

    const paginaSalarios = useMemo(() => {
        return Number(searchParamsSalarios.get("pagina") || "1");
    }, [searchParamsSalarios]);

    useEffect(() => {        
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }
        setIsLoading(true);
        const fetchData = async () => {
            setIsLoading(false);
            setRemoveLoading(true);
            await UtilidadeService.getTemporadas(true, Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const tmps = result.data.dado;
                    let lstTemporadasAux = result.data.dado.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            await DraftService.getBuscarPicksDraft(paginaSalarios, Number(codigoLiga), 1)
                .then((result) => {
                    setIsLoading(false);
                    const drafts = result.data.dado;
                    formRef.current?.setFieldValue("configuracao_Liga.codigo_Temporada", Number(drafts.pop()?.codigo_Temporada));
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        fetchData();

    }, [paginaSalarios, codigoLiga]);

    const handleSave = async (dados: IDetalheFranquia) => {
        setIsLoading(true);
        setIsLoading(false);

    };

    // const handleDelete = (id: number) => {
    //     if (window.confirm("Realmente deseja apagar?")) {
    //         FranquiaService.deleteById(id)
    //             .then((result) => {
    //                 setShowModalMensagem(true);
    //                 setDadosModal({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "success",
    //                     mensagem: "Registro excluido com sucesso!",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 setRedirecionar("/franquias");
    //             })
    //             .catch((errors) => {
    //                 setShowModalMensagem(true);
    //                 if (errors.response.status === 401) {
    //                     setDadosModal({
    //                         acao: true,
    //                         label: "",
    //                         tipo: "info",
    //                         mensagem: "Sessão expirada!",
    //                         display: "none",
    //                         titulo: "Atenção"
    //                     });
    //                     logout();
    //                     setRedirecionar("0");
    //                     return;
    //                 }
    //                 setDadosModal({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: errors.response.data.mensagem,
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //             });
    //     }
    // };

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        let temp = e.target.value;

        await DraftService.getBuscarPicksDraft(paginaSalarios, Number(codigoLiga), e.target.value)
            .then((result) => {
                setIsLoading(false);
                const drafts = result.data.dado;
                //setRows(drafts);                    
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    return (
        <LayoutBaseDePagina
            titulo="Lista de Picks"
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid  size={{xs:12, sm:12}} >
                            <Typography variant="h6">Lista de Picks</Typography>
                            <hr />
                        </Grid>
                        <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial">
                            <Grid  size={{xs:12, sm:6, md:3}} >
                                <SelectComponent
                                    required
                                    isExternalLoading={isLoading || edicao}
                                    label="Temporadas"
                                    name="configuracao_Liga.codigo_Temporada"
                                    items={lstTemporadas}
                                    defaultValue=""
                                    variant="outlined"
                                    onChange={handleSelectedTemporada}
                                />
                            </Grid>
                        </Grid>
                        {!removeLoading && <Loading />}
                        <Grid  size={{xs:12, sm:12}}   >
                            <Box sx={{
                                height: 'auto', width: '100%',backgroundColor: themeName === "light" ? "#cfcfcd" : "auto" ,
                                '& .super-app-theme--header': {
                                    backgroundColor: theme.palette.common.black,
                                    color: theme.palette.common.white
                                },
                                '& .super-app.negative': {
                                    color: 'red',
                                    fontWeight: 'bold'
                                },
                                '& .super-app.positive': {
                                   color: themeName === "light" ? "black" : "auto",
                                },
                            }}>
                               <DataGrid
                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                    getRowId={(rows) => rows.id}
                                    rows={rows}
                                    columns={columnsSalarios}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 4,
                                                page: paginaSalarios - 1,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[4, 8, 10, 25]}
                                    disableRowSelectionOnClick
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
}